const initialState = {
    callSession: null,
    room: null,
    isInGroupCall: null,
};
export const reducer = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case 'CALL-INFO/SET_CALL_SESSION_INFO':
            return { ...state, callSession: { ...payload } };
        case 'CALL-INFO/SET_ROOM_INFO':
            return { ...state, room: { ...payload } };
        case 'CALL-INFO/SET_IS_IN_GROUP_CALL':
            return { ...state, isInGroupCall: payload };
        default:
            return state;
    }
};
